import { render, staticRenderFns } from "./ShsIcon.vue?vue&type=template&id=4b61105c"
import script from "./ShsIcon.vue?vue&type=script&lang=js"
export * from "./ShsIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports